import Interface from "@/util/interface"

export default {
    data() {
        return {
            code: '',
            code1: '',
            code2: '',
            code3: '',
            code4: '',
            needPassword:false,
            error: false,
        }
    },
    watch: {
        code (val) {
            if (val) {
                this.code = val.length > 4 ? val.substr(0, 4) : val;
                let arr = val.split('');
                this.code1 = arr[0];
                this.code2 = arr[1];
                this.code3 = arr[2];
                this.code4 = arr[3];
            }
        }
    },
    filters: {
        formatDate: function (time) {
            return formatTimeToStr(time, "MM月dd日 hh:mm")
        },
        keepSecrect (val) {
            let phone = val.split(' ');
            let head = phone[1].substr(0, 3);
            let tail = phone[1].substr(-3);
            return `${phone[0]} ${head}****${tail}`;
        },
    },
    directives: {
        enterfocus: { // 进入时激活input,可直接输入
            inserted: function (el) {
                el.focus();
            }
        }
    },
    methods: {
        changeCode (e) {
            if (this.code.split('').length <= 1) {
                this.code = '';
                this.code1 = '';
            }
            this.$refs.otpInputs.focus();
        },
        confirmCancel () {
            let data = this.OTPdata;
            data['otp'] = `${this.code1}${this.code2}${this.code3}${this.code4}`;
            this.$http.post(applyForRefundTogether, data).then(res => {
                if (res.code === 200 && res.succ) {
                    this.error = false;
                    Toast('Cancel Successfully');
                } else {
                    this.error = true;
                    Toast(res.msg);
                }
            })
        },
        giveUpCancel () {
            this.$emit('giveUpCancel');
        },
        checkPassword(){
            if(this.code == ""){
                return
            }
            let params = {
                id :this.id,
                password:this.code
            }
            Interface.getData('get', Interface.live.check_password, params).then((res) => {
                if(res.code==0){
                    this.$toast.success("验证成功!")
                    this.live.isPasswordAuth = true
                    this.needPassword = false
                }else{
                    this.error = true
                    this.code=""
                    this.code1=""
                    this.code2=""
                    this.code3=""
                    this.code4=""
                }
            })
            return false
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/verify.js